export const getIsInitialShiftPollLoading = (state) => {
  return !!state.shifts.loading;
};
